import BenefitCtaBlockSection from './benefit-cta-block-section';

export default BenefitCtaBlockSection;
